<app-loading *ngIf="loading"></app-loading>

<ng-container *ngIf="!loading">
  <ng-container *ngIf="isDialog; else otpPage">
    <div class="otp-card">
      <button class="back-btn" type="button" (click)="onChangeSignupDetails()">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <h3 class="fs-22 pb-3 fw-bold mt-4">Verify mobile number</h3>
      <p>
        A text with a one-time password (OTP) has been<br />
        sent to your mobile number: <b>+91 {{ data?.phoneNumber }}</b>
        <a (click)="onChangeSignupDetails()"> Change</a>
      </p>

      <div class="form-group mt-10 mb-20 otp-input-wrapper">
        <input
          style="text-align: center; font-size: 20px"
          id="xcom_verify_otp_page_otp"
          class="form-control form--control"
          type="text"
          minlength="6"
          maxlength="6"
          [(ngModel)]="otpDigits"
          (input)="isOtpValid()"
          autocomplete="one-time-code"
          placeholder="One Time Password (OTP)" />
      </div>

      <div class="mt-10" fxLayout="row" fxLayoutAlign="center center">
        <button
          type="submit"
          [disabled]="isLoading || !otpValid"
          class="btn-continue"
          [ngClass]="{ 'btn-valid': otpValid }"
          (click)="onVerifyOtp()">
          <ng-container *ngIf="!isLoading; else spinnerTpl">Continue</ng-container>
          <ng-template #spinnerTpl>
            <mat-spinner [diameter]="22"></mat-spinner>
          </ng-template>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Full screen page version (for /auth/otp route) -->
  <ng-template #otpPage>
    <div class="otp-page-container">
      <div class="otp-card">
        <button class="back-btn" type="button" (click)="onChangeSignupDetails()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <h3 class="fs-22 pb-3 fw-bold">Verify mobile number</h3>
        <p>
          A text with a one-time password (OTP) has been<br />
          sent to your mobile number: <b>+91 {{ data?.phoneNumber }}</b>
          <a (click)="onChangeSignupDetails()"> Change</a>
        </p>

        <div class="form-group mt-10 mb-20 otp-input-wrapper">
          <input
            style="text-align: center; font-size: 20px"
            id="xcom_verify_otp_page_otp"
            class="form-control form--control"
            type="text"
            minlength="6"
            maxlength="6"
            [(ngModel)]="otpDigits"
            (input)="isOtpValid()"
            autocomplete="one-time-code"
            placeholder="One Time Password (OTP)" />
        </div>

        <div class="mt-10" fxLayout="row" fxLayoutAlign="center center">
          <button
            type="submit"
            [disabled]="isLoading || !otpValid"
            class="btn-continue"
            [ngClass]="{ 'btn-valid': otpValid }"
            (click)="onVerifyOtp()">
            <ng-container *ngIf="!isLoading; else spinnerTpl">Continue</ng-container>
            <ng-template #spinnerTpl>
              <mat-spinner [diameter]="22"></mat-spinner>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
